import SelectedFilters from "./SelectedFilters"
import styles from "./AppliedFiltersBar.module.css"

/**
 * Top-of-grid surface for the applied-filter chips.
 * Reuses `<SelectedFilters />` — the same component the filter dialog uses —
 * so the pill list stays in sync between the dialog and the page.
 *
 * The component returns `null` internally when no filters are applied, and
 * the wrapper's `:empty` CSS rule then collapses the spacing.
 */
export default function AppliedFiltersBar() {
  return (
    <div className={styles.bar}>
      <SelectedFilters />
    </div>
  )
}
